import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { BundledProduct } from 'store/product/types';
import getBundleGroups from 'utils/StudioSearchProductPage/getBundleGroups';
import { PublicAssetProductState } from '../types';

export interface SelectPublicAssetBundleProductsPayload {
  bundleGroup: any;
  productItem: AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem;
}

const findPreviewForSelectedBundleProduct = (
  bundleGroup: AppBundle.Api.Entity.App.V1.AbstractProduct.IBundleGroup[],
  selectedProduct: BundledProduct,
) => {
  const targetGroup = bundleGroup.find((group) => group.bundleGroupId === selectedProduct.bundleGroupId);
  const targetItem = targetGroup?.items?.find((item) => item.productId === selectedProduct.productId);
  const [first, second] = targetItem?.previews || [];
  return second || first;
};

const extractPreviewsFromBundleProducts = (
  bundleProducts: BundledProduct[],
  currentProduct?: AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem,
  selectedAbstractProduct?: AppBundle.Api.Entity.App.V1.IAbstractProduct,
) => {
  const bundleGroups = currentProduct?.productId
    ? getBundleGroups(currentProduct?.productId, selectedAbstractProduct)
    : [];
  let forcedPreview;
  bundleProducts.forEach((sp) => {
    if (sp.productId === 0) return;
    const preview = findPreviewForSelectedBundleProduct(bundleGroups, sp);
    if (preview) {
      // force preview
      forcedPreview = {
        0: preview,
      };
    }
  });
  return forcedPreview;
};

const selectBundleProductReducer = (
  state: PublicAssetProductState,
  action: PayloadAction<SelectPublicAssetBundleProductsPayload>,
) => {
  const { bundleGroup, productItem } = action.payload;
  const { selectedBundleProducts } = state;
  const { bundleGroupId } = bundleGroup;
  const useMultipleSelection = bundleGroup.canSelectMultiple;

  const alreadySelected = selectedBundleProducts.find(
    (sp) => sp.bundleGroupId === bundleGroupId && sp.productId === productItem.productId,
  );
  if (alreadySelected) {
    return;
  }
  // remove none option
  let updatedSelectedBundledProducts =
    selectedBundleProducts?.filter((sp) => !(sp.bundleGroupId === bundleGroupId && sp.productId === 0)) || [];

  if (!useMultipleSelection) {
    // remove already selected options
    updatedSelectedBundledProducts = selectedBundleProducts?.filter((sp) => sp.bundleGroupId !== bundleGroupId) || [];
  }
  updatedSelectedBundledProducts.push({
    bundleGroupId,
    productId: productItem.productId,
    categoryId: productItem.categoryId || 1,
  });
  state.selectedBundleProducts = updatedSelectedBundledProducts;
  if (productItem.productId === 0) {
    state.forcedPreviews = {};
  }
  const forcedPreview = extractPreviewsFromBundleProducts(
    updatedSelectedBundledProducts,
    state.currentProduct,
    state.selectedAbstractProduct,
  );
  state.forcedPreviews = forcedPreview;
};

export default selectBundleProductReducer;
